module.exports = __webpack_public_path__ + "static/img/home_medication_western.de3fd75e.webp";